export const authRoutes = {
	login: '/login',
	passwordReset: '/password-reset',
	passwordResetContinue: '/password-reset-continue'
} as const
